import { useQuery } from "@tanstack/react-query";
import { clicksService } from "@/services/ClicksService";

/**
 * Whether the server filters "contains" / "doesn't contain" (clicks_filter_modes).
 * Asked once per visit; before the migration is deployed (PGRST202) the editor
 * offers only "is" / "is not" - an older server reads any other mode as "is not".
 */
export function useTextFilterModes(): boolean {
  const query = useQuery({
    queryKey: ["clicks-filter-modes"],
    queryFn: () => clicksService.getFilterModes(),
    staleTime: Infinity,
    retry: (n, error) => (error as { code?: string } | null)?.code !== "PGRST202" && n < 1,
    throwOnError: false,
  });
  return Boolean(query.data?.includes("contains"));
}
